import { createVideoCallingSlice as createSlice, type VideoCallingSlice } from "@tellescope/video-calling";
import type { EnduserSliceCreator } from "../types";

/**
 * Video calling slice for portal-web.
 * Uses the shared createVideoCallingSlice from @tellescope/video-calling package.
 */
export const createVideoCallingSlice: EnduserSliceCreator<VideoCallingSlice> = (set, get) => {
  return createSlice(
    (updates) => set((state) => ({ videoCalling: { ...state.videoCalling, ...updates } })),
    () => get().videoCalling
  );
};
